import { render, staticRenderFns } from "./ShowAperturaTab.vue?vue&type=template&id=1a54c94e&scoped=true"
import script from "./ShowAperturaTab.vue?vue&type=script&lang=js"
export * from "./ShowAperturaTab.vue?vue&type=script&lang=js"
import style0 from "./ShowAperturaTab.vue?vue&type=style&index=0&id=1a54c94e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a54c94e",
  null
  
)

export default component.exports